module.exports = __webpack_public_path__ + "static/img/6357_phase_function_Paper_PointsHejduk_Prediction.54488d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6357_phase_function_Paper_PointsHejduk_Prediction.png
// module id = J/fA
// module chunks = 0